import { Sound } from "@pixi/sound";
import { Sprite, Text, TextStyle, Texture } from "pixi.js";
import { DefaultButton } from "./DefaultButton";

export class ButtonWithTextAndIcon extends DefaultButton {
    protected textField: Text;
    protected buttonIcon: Sprite;
    protected get buttonText(): string {
        return this.textField.text;
    }
    protected set buttonText(value: string) {
        this.textField.text = value;
        this.updateTextAndIconPositions();
    }

    public constructor(texture: Texture, text: string, textStyle: TextStyle, iconTexture: Texture, pressSound?: Sound) {
        super(texture, pressSound);
        this.textField = new Text(text, textStyle);
        this.defaultView.addChild(this.textField);
        this.buttonIcon = new Sprite(iconTexture);
        this.defaultView.addChild(this.buttonIcon);
        this.updateTextAndIconPositions();
    }

    protected updateTextAndIconPositions() {
        const contentWidth = this.textField.width + this.buttonIcon.width;
        this.textField.position.set(this.width * 0.5 - contentWidth * 0.5, 23);
        this.buttonIcon.position.set(this.textField.x + this.textField.width + 6, 20);
    }
}
